import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { yup } from '../services/yup';
import { cyrillicAlphabetRegex } from '../constants';

export const useFirstNameCyrillicValidation = () => {
  const intl = useIntl();

  return useMemo(
    () => yup.string()
      .trim()
      .required(intl.formatMessage({ id: 'common.errors.required.long' }))
      .matches(cyrillicAlphabetRegex, { message: intl.formatMessage({ id: 'common.errors.cyrillic' }) })
      .min(2, intl.formatMessage({ id: 'common.errors.firstName.minMax' }, { min: 2, max: 20 }))
      .max(20, intl.formatMessage({ id: 'common.errors.firstName.minMax' }, { min: 2, max: 20 })),
    [intl],
  );
};
